import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import PopperMU, { PopperPlacementType } from '@material-ui/core/Popper';
import * as React from 'react';

interface IPopper {
  open: boolean;
  anchorEl: any;
  styles?: {
    root?: React.CSSProperties;
    content?: React.CSSProperties;
  };
  style?: React.CSSProperties;
  placement?: PopperPlacementType;
  children: any;
  className?: string;
};

/**
 * Composant qui affiche un popper sur une zone
 * @param props:IPopper
 * @returns JSX.ELement
 */
const Popper = (props: IPopper) => {
    const customParamPopperMU = {};
    const customParamCard = {};
    const customParamCardContent = {};

    props.className != undefined && props.className != null ? customParamPopperMU["className"] = props.className : '';
    props.style != undefined && props.style != null ? customParamPopperMU["style"] = props.style : '';

    props.styles != undefined && props.styles != null && props.styles.root != undefined ? customParamCard['style'] = props.styles.root : '';
    props.styles != undefined && props.styles != null && props.styles.content != undefined ? customParamCardContent['style'] = props.styles.content : '';
  return (
    <PopperMU
      open={props.open}
      anchorEl={props.anchorEl}
      placement={props.placement != undefined && props.placement != null ? props.placement : 'top'}
      {...customParamPopperMU}
    >
      <Card {...customParamCard}>
        <CardContent {...customParamCardContent}>
          {props.children}
        </CardContent>
      </Card>
    </PopperMU>
  );
}

export default Popper;